import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    models: [
      {
        value: 'JUKE',
        name: 'NISSAN JUKE',
        image: '/static/nissan-juke.png'
      },
      {
        value: 'NOVI QASHQAI',
        name: 'NISSAN QASHQAI',
        image: '/static/nissan-qashqai.png'
      },
      {
        value: 'NAVARA',
        name: 'NISSAN NAVARA',
        image: '/static/nissan-navara.png'
      },
      {
        value: 'MICRA',
        name: 'NISSAN MICRA',
        image: '/static/nissan-micra.png'
      },
      {
        value: 'NOVI X-TRAIL',
        name: 'NISSAN X-TRAIL',
        image: '/static/nissan-xtrail.jpg'
      },
      {
        value: 'Drugo',
        name: 'Drugo',
        image: ''
      }
    ],
    dealers: [
      {
        'dealerId': 89150075,
        'suggestedName': 'AK KOMPRESOR d.o.o., Beograd'
      },
      {
        'dealerId': 410013,
        'suggestedName': 'AUTO MARTON d.o.o., Subotica'
      },
      {
        'dealerId': 89150020,
        'suggestedName': 'HIT AUTO d.o.o., Beograd'
      },
      {
        'dealerId': 410018,
        'suggestedName': 'LF AUTO CENTAR d.o.o., Beograd'
      },
      {
        'dealerId': 89150183,
        'suggestedName': 'STOJANOV AUTO d.o.o., Novi Sad'
      },
      {
        'dealerId': 89150189,
        'suggestedName': 'NIKOM CARS, Kragujevac'
      }
    ],
    titles: [
      'GDIN',
      'GĐA',
      'GĐICA'
    ],
    times: [
      '8:00',
      '9:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00'
    ],
    monthsLong: [
      'Januar',
      'Februar',
      'Mart',
      'April',
      'Maj',
      'Jun',
      'Jul',
      'Avgust',
      'Septembar',
      'Oktobar',
      'Novembar',
      'Decembar'
    ],
    monthsShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'Maj',
      'Jun',
      'Jul',
      'Avg',
      'Sep',
      'Okt',
      'Nov',
      'Dec'
    ],
    dateNamesMin: [
      'ne',
      'po',
      'ut',
      'sr',
      'če',
      'pe',
      'su'
    ],
    dateNamesShort: [
      'ned',
      'pon',
      'uto',
      'sre',
      'čet',
      'pet',
      'sub'
    ],
    dateNamesLong: [
      'nedelja',
      'ponedeljak',
      'utorak',
      'sreda',
      'četvrtak',
      'petak',
      'subota'
    ],
    services: [
      {
        'name': 'Redovan servisni pregled',
        'value': 'RedovanServisniPregled'
      },
      {
        'name': 'Dodatna oprema',
        'value': 'DodatnaOprema'
      },
      {
        'name': 'Informacije o paketima',
        'value': 'InformacijeoPaketima'
      },
      {
        'name': 'Ugovor o održavanju',
        'value': 'UgovoroOdrzavanju'
      },
      {
        'name': 'Popravka karoserije',
        'value': 'PopravkaKaroserije'
      },
      {
        'name': 'Gume',
        'value': 'Gume'
      },
      {
        'name': 'Vetrobransko staklo',
        'value': 'VetrobranskoStaklo'
      },
      {
        'name': 'Ostalo',
        'value': 'Ostalo'
      }
    ]
  },
  getters: {
  },
  mutations: {
  }
})



// WEBPACK FOOTER //
// ./src/store/dropdowns.js